import React, { Component, PropTypes } from 'react';
import * as SvgIcons from 'components/Material/SvgIcons';
import { Toolbar, ToolbarGroup, ToolbarButton } from 'Cio/Toolbar';

class PageLayoutEditorToolbar extends Component {
  static propTypes = {
    closeLayoutEditor: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  render() {
    const { closeLayoutEditor, ...other } = this.props;

    const { getIntlMessage } = this.context;
    return (
      <Toolbar center key="edit" {...other}>
        <ToolbarGroup>
          <ToolbarButton
            onTouchTap={closeLayoutEditor}
            tooltip={getIntlMessage('menu.Back')}
          >
            <SvgIcons.NavigationArrowBack />
          </ToolbarButton>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

export default PageLayoutEditorToolbar;



// WEBPACK FOOTER //
// ./src/js/components/Page/LayoutOverview/PageLayoutEditorToolbar.js